//const isTouch = window.matchMedia('(pointer:coarse)').matches;

export default function () {
}
